@if (expanded()) {
  <div class="scrim" animate.enter="fade-in" animate.leave="fade-out" (click)="collapse()"></div>
}

<nav class="step-bar" [attr.aria-label]="'stepper.navigation' | translate">
  @if (expanded()) {
    <div id="step-bar-list" class="list" animate.enter="slide-in" animate.leave="slide-out">
      <ul class="steps">
        @for (label of labels(); track label; let i = $index) {
          <li>
            <button
              type="button"
              class="step"
              [class.selected]="i === selectedIndex()"
              [attr.aria-current]="i === selectedIndex() ? 'step' : null"
              (click)="choose(i)"
            >
              <span class="marker" [class.done]="completed()[i]" aria-hidden="true">
                @if (completed()[i]) {
                  <mat-icon>check</mat-icon>
                }
              </span>
              <span class="label">{{ label | translate }}</span>
              @if (completed()[i]) {
                <span class="cdk-visually-hidden">{{ 'stepper.completed' | translate }}</span>
              }
            </button>
          </li>
        }
      </ul>
    </div>
  }

  <button
    #toggle
    type="button"
    class="toggle"
    aria-controls="step-bar-list"
    [attr.aria-expanded]="expanded()"
    (click)="flip()"
  >
    <span class="marker" [class.done]="completed()[selectedIndex()]" aria-hidden="true">
      @if (completed()[selectedIndex()]) {
        <mat-icon>check</mat-icon>
      }
    </span>
    <span class="label">{{ labels()[selectedIndex()] | translate }}</span>
    <mat-icon class="chevron" aria-hidden="true">expand_less</mat-icon>
  </button>
</nav>
